<h1>{{ supplierId ? 'Editace zpracovatele' : 'Založení zpracovatele' }}</h1>

<div [loading]="loading">
  <div *ngIf="!loading">
    <div>
      <gmt-project-subject [subject]="supplier"></gmt-project-subject>
    </div>

    <div class="actions">
      <gmt-button *ngIf="supplier.id === undefined" [gmtDisabled]="!isValid()" [clickAction]="onCreate">Uložit</gmt-button>
      <gmt-button *ngIf="supplier.id !== undefined" [gmtDisabled]="!isValid()" [clickAction]="onUpdate">Uložit</gmt-button>
    </div>
  </div>
</div>
